import { List } from 'immutable';
import React from 'react';
import { useReframe } from 'nike-re-framejs';

import { SEARCH_RESULT_MATCHES_BOXSTORE } from '../services/results';
import { Tournament } from '@/nikeone/components/TournamentList';
import withSportHeader from '@/common/components/sportWrapper';
import i18n from '@i18n';
import BoxOptionsContext, {
    NIKEONE,
    SEARCH_LIVE,
    SEARCH_PREMATCH,
    SEARCH_RESULT
} from '@/nikeone/context/BoxOptionsContext';
import { useTurboLivePush } from 'nike-ui/src/components/turboLive/push/overview/useTurboLivePush';
import { parseBoxId } from 'nike-ui/src/components/turboLive/push/utils';

function isBoxOfCorrectType(boxOptions, box) {
    return (
        (boxOptions === SEARCH_PREMATCH && !box.get('prematchHierarchy', List()).isEmpty()) ||
        (boxOptions === SEARCH_LIVE && !box.get('liveSportEventIds', List()).isEmpty()) ||
        (boxOptions === SEARCH_RESULT && !box.get('resultBetsHierarchy', List()).isEmpty())
    );
}

export default function Matches({ boxOptions, text }) {
    const derefSub = useReframe();
    const allBoxes = derefSub(['nikeone/boxes', SEARCH_RESULT_MATCHES_BOXSTORE]);
    if (!allBoxes || !allBoxes.size) {
        return null;
    }
    const filteredBoxes = allBoxes.filter(Boolean).filter(box => isBoxOfCorrectType(boxOptions, box));
    if (!filteredBoxes.size) {
        return null;
    }

    return (
        <div>
            <div className="header-section">{i18n(text)}</div>
            <BoxOptionsContext.Provider value={boxOptions || NIKEONE}>
                {filteredBoxes
                    .groupBy(box => box.get('sportId'))
                    .sortBy((box, sportId) => sportId)
                    .map((boxes, sportId) =>
                        boxOptions.live ? (
                            <LiveSport
                                boxes={boxes}
                                key={sportId}
                                sportId={sportId}
                                sportDisplayName={boxes.first().get('subtitle')}
                            />
                        ) : (
                            <Sport
                                boxes={boxes}
                                key={sportId}
                                sportId={sportId}
                                sportDisplayName={boxes.first().get('subtitle')}
                            />
                        )
                    )
                    .toList()}
            </BoxOptionsContext.Provider>
        </div>
    );
}

const LiveSport = props => {
    useTurboLivePush(props.boxes.map((box, boxId) => parseBoxId(boxId)?.tournamentId).toSet());
    return <Sport {...props} />;
};

const Sport = ({ sportId, sportDisplayName, boxes }) =>
    withSportHeader(
        sportId,
        sportDisplayName,
        boxes
            .sortBy((box, boxId) => boxId)
            .map((box, boxId) => (
                <Tournament
                    key={boxId}
                    tour={{ boxId, label: box.getIn(['title']) }}
                    boxStore={SEARCH_RESULT_MATCHES_BOXSTORE}
                    implicitExpand
                    sportId={sportId}
                />
            ))
            .toList()
    );
